












































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Print from 'vue-print-nb'
import moment from "vue-moment";
Vue.use(Print);
@Component
export default class PrinterHandoverSessionCustomerReport extends AbpBase{
  @Prop({ type: Boolean, default: false }) value: boolean;
  id : number;
  invoiceOrders = [];
  get loading(){
      return false;
  }
  async created(){
    this.id = +this.$root.$router.currentRoute.params.id;
    await this.$store
      .dispatch({
          type:'handoverSession/getHandoverSessionAOGroupReport',
          data: { id : this.id}
      })
      .then((res) => {
        this.invoiceOrders = res.items;
        this.invoiceOrders.forEach((invoiceOrder) => {
          let index = 0;
          if(invoiceOrder.products != undefined){
            invoiceOrder.products.forEach(function(item) {
              item.orderNo = index + 1;
              index++;
            });
          }
        });
      });
  }
}

window.onbeforeprint = BeforePrint;
let heightA4 = 950;

function BeforePrint () {
    var elements = document.getElementsByClassName("box");
    for (var i = 0; i < elements.length; i++) {
        let element = elements[i] as HTMLElement;
        let rootHeigth = element.clientHeight;
        let division = Math.floor(rootHeigth / heightA4);
        let remainder = rootHeigth % heightA4;
        if(remainder > 0){
          let remainderHeight = remainder > 0 ? 1 : 0;
          let newHeight = (division + remainderHeight) * 950;
          element.style.height = newHeight + "px";
        }
    }
}
